module.exports = __webpack_public_path__ + "img/contacto.e8f42c4c.png";